import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { getProductAction } from '@finect/front-resources/Products';
import { ShoppingCart } from '@finect/tabular-icons/shoppingCart';
import { BuyBlock } from '../partials';
export var BuyButton = function BuyButton(_ref) {
  var product = _ref.product,
    onAction = _ref.onAction,
    _ref$isCompact = _ref.isCompact,
    isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width;
  var action = getProductAction(product);
  var icon = action.icon;
  return React.createElement(BuyBlock, {
    isCompact: isCompact
  }, React.createElement(Button, {
    secondary: true,
    disabled: !product.entity.transactionable,
    onClick: onAction,
    width: width
  }, React.createElement("span", null, icon ? React.createElement(ShoppingCart, {
    size: "18",
    strokeWidth: "2.5"
  }) : null, action.action)));
};